<template>
    <zk-admin-table title="精准关怀体检申请" :loading="loading" :table="table" @change="handleTableChange">
        <template v-slot:buttons>
            <el-row style="float: right">
                <el-button type="primary" size="small" @click="handleAdd" icon="el-icon-plus">申请体检</el-button>
                <el-button type="default" size="small" @click="getData" icon="el-icon-refresh">刷新</el-button>
            </el-row>
        </template>

        <template v-slot:search>
            <zk-search-form-inline :form="search" @search="getData">
                <el-form-item label="姓名">
                    <el-input v-model.trim="search.name" clearable style="width:120px"></el-input>
                </el-form-item>
                <el-form-item label="身份证号">
                    <el-input v-model.trim="search.id_card" clearable></el-input>
                </el-form-item>
                <el-form-item label="状态">
                     <el-select v-model="search.status" placeholder="全部" clearable style="width:120px">
                        <el-option label="已申请" value="0"></el-option>
                        <el-option label="已审核" value="1"></el-option>
                        <el-option label="审核不通过" value="-1"></el-option>
                        <el-option label="已收费" value="2"></el-option>
                    </el-select>
                </el-form-item>
            </zk-search-form-inline>
        </template>

        <el-table-column type="index" width="50" align="center" />
        <el-table-column prop="secondary_unit" label="二级单位" width="150" align="center" />
        <el-table-column prop="name" label="姓名" width="100" align="center" />
        <el-table-column prop="id_card" label="身份证号" width="170" align="center" />
        <el-table-column prop="status" label="状态" width="100" align="center">
            <template slot-scope="scope">
                <el-tag v-if="scope.row.status == 0" type="primary" size="mini">已申请</el-tag>
                <el-tag v-else-if="scope.row.status == 1" type="success" size="mini">已审核</el-tag>
                <el-tag v-else-if="scope.row.status == -1" type="danger" size="mini">审核不通过</el-tag>
                <el-tag v-else-if="scope.row.status == 2" type="warning" size="mini">已收费</el-tag>
            </template>
        </el-table-column>
        <el-table-column prop="items" label="检查项目" align="center">
            <template slot-scope="scope">
                <el-tag v-for="(item, index) in scope.row.items" :key="index" size="mini" style="margin-right: 5px;">{{ item }}</el-tag>
            </template>
        </el-table-column>
        <el-table-column prop="total_cost" label="费用合计" width="100" align="center">
            <template slot-scope="scope">
                {{ scope.row.total_cost }} 元
            </template>
        </el-table-column>
        <el-table-column prop="create_time" label="申请时间" width="160" align="center" />
        <el-table-column prop="applicant" label="申请人" width="100" align="center" />
        <el-table-column prop="audit_time" label="审核时间" width="160" align="center" />
        <el-table-column prop="auditor" label="审核人" width="100" align="center" />
        
        <el-table-column align="center" width="120" label="操作" fixed="right">
            <template slot-scope="scope">
                <el-button size="mini" type="primary" @click="handleUpdate(scope.row)" v-if="scope.row.status === 0 || scope.row.status === -1">编辑</el-button>
                <el-button size="mini" type="danger" @click="handleDelete(scope.row)" v-if="scope.row.status === 0 || scope.row.status === -1">删除</el-button>
            </template>
        </el-table-column>

        <template v-slot:dialog>
            <el-dialog :title="form.id ? '编辑申请' : '填写申请表单'" :visible.sync="dialogVisible" width="60%" :close-on-click-modal="false">
                <el-form ref="form" :model="form" label-width="100px" :rules="rules">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="姓名" prop="name">
                                <el-input v-model.trim="form.name" placeholder="请输入姓名"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="身份证号" prop="id_card">
                                <el-input v-model.trim="form.id_card" placeholder="请输入身份证号"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="二级单位" prop="secondary_unit">
                                <el-input v-model.trim="form.secondary_unit" placeholder="请输入二级单位名称"></el-input>
                            </el-form-item>
                        </el-col>
                         <el-col :span="12">
                             <el-form-item label="费用合计">
                                <span style="color: red; font-weight: bold; font-size: 16px;">{{ currentTotalCost }} 元</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="检查项目" prop="items">
                                <el-checkbox-group v-model="form.items">
                                    <el-checkbox v-for="item in checkItems" :label="item.label" :key="item.label" name="items">
                                        {{ item.label }} ({{ item.price }}元)
                                    </el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="handleSubmit" :loading="loading">确 定</el-button>
                </span>
            </el-dialog>
        </template>
    </zk-admin-table>
</template>

<script>
const CHECK_ITEMS = [
    { label: 'CTA', price: 1200 },
    { label: 'MRA', price: 1000 },
    { label: '心脏彩超', price: 300 },
    { label: '颈动脉彩超', price: 200 },
    { label: '胸部CT', price: 400 }
];

export default {
    name: 'keycare_register',
    path: '/main/keycare/register',
    meta: {
        title: '精准关怀体检申请',
    },
    data() {
        return {
            loading: false,
            dialogVisible: false,
            search: {
                name: '',
                id_card: '',
                status: ''
            },
            table: {
                columns: [],
                data: [],
                total: 0,
                page: 1,
                pageSize: 20
            },
            form: {
                name: '',
                id_card: '',
                secondary_unit: '',
                items: [],
                total_cost: 0
            },
            checkItems: CHECK_ITEMS,
            rules: {
                name: [
                    { required: true, message: '请输入姓名', trigger: 'blur' }
                ],
                id_card: [
                    { required: true, message: '请输入身份证号', trigger: 'blur' },
                    { pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '身份证号格式不正确', trigger: 'blur' }
                ],
                secondary_unit: [
                    { required: true, message: '请输入二级单位', trigger: 'blur' }
                ],
                items: [
                    { type: 'array', required: true, message: '请至少选择一个检查项目', trigger: 'change' }
                ]
            }
        }
    },
    computed: {
        currentTotalCost() {
            let total = 0;
            if (this.form.items && this.form.items.length > 0) {
                this.form.items.forEach(itemName => {
                    const item = this.checkItems.find(i => i.label === itemName);
                    if (item) {
                        total += item.price;
                    }
                });
            }
            return total;
        }
    },
    methods: {
        handleTableChange(e) {
            this.table = Object.assign({}, this.table, e);
            this.getData();
        },
        async getData() {
            this.loading = true;
            try {
                // Mock data since backend might not exist
                // const resp = await this.$http.get('/keycare/register', {
                //     params: {
                //         page: this.table.page,
                //         pageSize: this.table.pageSize,
                //         ...this.search
                //     }
                // });
                // this.table.data = resp.data.data;
                // this.table.total = resp.data.total;
                
                // Using mock data for demonstration if API fails or for initial implementation
                // In a real scenario, uncomment the API call above
                
                // Simulate API call
                const mockData = [
                    { 
                        id: 1, 
                        secondary_unit: '第一采油厂',
                        name: '张三', 
                        id_card: '110101199001011234', 
                        items: ['CTA', 'MRA'], 
                        total_cost: 2200,
                        status: 0,
                        applicant: '王五',
                        create_time: '2023-01-01 10:00:00',
                        audit_time: '',
                        auditor: ''
                    },
                    { 
                        id: 2, 
                        secondary_unit: '第二采油厂',
                        name: '李四', 
                        id_card: '110101199202025678', 
                        items: ['心脏彩超'], 
                        total_cost: 300,
                        status: 1,
                        applicant: '赵六',
                        create_time: '2023-01-02 11:30:00',
                        audit_time: '2023-01-03 09:00:00',
                        auditor: '管理员'
                    },
                    { 
                        id: 3, 
                        secondary_unit: '第三采油厂',
                        name: '王五', 
                        id_card: '110101199202025679', 
                        items: ['心脏彩超', '胸部CT'], 
                        total_cost: 700,
                        status: 2,
                        applicant: '赵六',
                        create_time: '2023-01-04 11:30:00',
                        audit_time: '2023-01-05 09:00:00',
                        auditor: '管理员'
                    }
                ];
                
                // Simple filter for mock data
                let filteredData = mockData.filter(item => {
                    let match = true;
                    if (this.search.name && !item.name.includes(this.search.name)) match = false;
                    if (this.search.id_card && !item.id_card.includes(this.search.id_card)) match = false;
                    if (this.search.status && item.status != this.search.status) match = false;
                    return match;
                });

                this.table.data = filteredData;
                this.table.total = filteredData.length;
                
            } catch (e) {
                this.$message.error(e.message || '获取数据失败');
            }
            this.loading = false;
        },
        handleAdd() {
            this.form = {
                name: '',
                id_card: '',
                secondary_unit: '',
                items: [],
                total_cost: 0
            };
            this.dialogVisible = true;
            this.$nextTick(() => {
                if (this.$refs.form) this.$refs.form.clearValidate();
            });
        },
        handleUpdate(row) {
            this.form = JSON.parse(JSON.stringify(row));
            this.dialogVisible = true;
            this.$nextTick(() => {
                if (this.$refs.form) this.$refs.form.clearValidate();
            });
        },
        handleDelete(row) {
             this.$confirm('确认删除该申请吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$message.success('删除成功 (演示)');
                // In real app: await this.$http.delete(`/keycare/register/${row.id}`); this.getData();
            }).catch(() => {});
        },
        async handleSubmit() {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    this.loading = true;
                    try {
                        this.form.total_cost = this.currentTotalCost;
                        // Mock submission
                        // if (this.form.id) {
                        //     await this.$http.put(`/keycare/register/${this.form.id}`, this.form);
                        // } else {
                        //     await this.$http.post('/keycare/register', this.form);
                        // }
                        
                        await new Promise(resolve => setTimeout(resolve, 500)); // Simulate delay
                        this.$message.success('提交成功 (演示)');
                        this.dialogVisible = false;
                        this.getData();
                    } catch (e) {
                        this.$message.error(e.message || '提交失败');
                    }
                    this.loading = false;
                }
            });
        }
    },
    mounted() {
        this.getData();
    }
}
</script>

<style lang="scss" scoped>
</style>
